import { render, staticRenderFns } from "./WheelInspectionModal.vue?vue&type=template&id=47ac5af2&scoped=true"
import script from "./WheelInspectionModal.vue?vue&type=script&lang=js"
export * from "./WheelInspectionModal.vue?vue&type=script&lang=js"
import style0 from "./WheelInspectionModal.vue?vue&type=style&index=0&id=47ac5af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac5af2",
  null
  
)

export default component.exports